import React from 'react';
import { shallow } from 'enzyme';
import CashflowNotRequired from '../CashflowNotRequired';

describe('CashflowNotRequired', () => {
  let wrapper;

  beforeAll(() => {
    wrapper = shallow(<CashflowNotRequired />);
  });

  describe('#render', () => {
    it('should return obj', () => {
      const cashflowElem = wrapper.find('h3');

      expect(typeof wrapper).toBe('object');
      expect(cashflowElem.text()).toEqual(
        'Additional cash flow analysis is not required for this product'
      );
    });
  });
});
